import CheckboxGroup from "common/Components/CheckboxGroup/CheckboxGroup";
import React from "react";

// please update value handling
const ExlyCheckboxGroup = (props) => {
  const { input, meta, onChange, ...rest } = props;

  return (
    <CheckboxGroup
      error={
        (meta.error || meta.submitError) &&
        meta.touched &&
        (meta.error || meta.submitError)
      }
      {...input}
      {...rest}
      onChange={(value) => {
        input.onChange(value);
        if (onChange) onChange(value);
      }}
    />
  );
};

export default ExlyCheckboxGroup;
